import { getCurrentUser, getUserSettings } from '../api/users_institutions';

// Base filenames (no extension) of the .mp3 files in frontend/public/NotifSounds/ -- Settings.jsx's
// dropdown lists these, and UserSettings.notif_sound (see api/models.py) stores one of them.
export const AVAILABLE_NOTIF_SOUNDS = ['notif1', 'notif2'];
export const DEFAULT_NOTIF_SOUND = 'notif1';

// Plays a sound by name directly, ignoring UserSettings.mute_notification -- used by Settings.jsx's
// dropdown so picking a sound previews it immediately even while notifications are muted (the
// user is actively auditioning it, not receiving a real notification).
export const previewNotificationSound = (soundName) => {
    try {
        const audio = new Audio(`/NotifSounds/${soundName || DEFAULT_NOTIF_SOUND}.mp3`);
        audio.play().catch((error) => {
            console.error('Error playing notification sound preview:', error);
        });
    } catch (error) {
        console.error('Error loading notification sound preview:', error);
    }
};

// Plays the current user's chosen notification sound (UserSettings.notif_sound), unless they've
// muted notifications. Fetches UserSettings fresh on every call rather than caching it locally --
// announcements/notifications/chat messages aren't frequent enough for that to matter, and this
// guarantees the mute toggle and sound choice both take effect immediately everywhere, without
// needing a shared store kept in sync across components.
export const playNotificationSound = async () => {
    const currentUser = getCurrentUser();
    if (!currentUser?.id) return;
    try {
        const settings = await getUserSettings(currentUser.id);
        if (settings?.mute_notification) return;
        previewNotificationSound(settings?.notif_sound);
    } catch (error) {
        console.error('Error loading notification sound settings:', error);
    }
};
